var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        visible: _vm.visible,
        title: _vm.modalTitle,
        size: "xl",
        "hide-footer": "",
        "no-close-on-backdrop": ""
      },
      on: {
        hidden: function($event) {
          return _vm.$emit("close")
        }
      }
    },
    [
      _c("div", { staticClass: "row mb-5" }, [
        _c("div", { staticClass: "col-md-10 mt-3" }, [
          _c("label", [_vm._v("Nombre parámetro")]),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.name,
                expression: "name"
              }
            ],
            staticClass: "form-control",
            attrs: { placeholder: "Nombre del parámetro" },
            domProps: { value: _vm.name },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.name = $event.target.value
              }
            }
          })
        ]),
        _c(
          "div",
          { staticClass: "col-md-2 mt-3 text-right" },
          [
            _c("feather-icon", {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: "Agregar parámetro",
                  expression: "'Agregar parámetro'"
                }
              ],
              attrs: { color: "green", size: "18", icon: "PlusCircleIcon" },
              on: { click: _vm.addSubParameter }
            })
          ],
          1
        ),
        _c("div", { staticClass: "col-md-12 mt-3" }, [
          _c("div", { staticClass: "grid-striped" }, [
            _c(
              "ul",
              { staticClass: "list-group mt-5" },
              [
                _c(
                  "draggable",
                  {
                    staticClass: "cursor-move",
                    attrs: { group: { name: "paramList" } },
                    model: {
                      value: _vm.parameters,
                      callback: function($$v) {
                        _vm.parameters = $$v
                      },
                      expression: "parameters"
                    }
                  },
                  _vm._l(_vm.parameters, function(param, index) {
                    return _c(
                      "li",
                      {
                        key: "param-" + index,
                        staticClass: "list-group-item",
                        attrs: { id: "param-" + index }
                      },
                      [
                        _c("ParameterItem", {
                          attrs: { param: param, "is-editing": param.inEdit },
                          on: {
                            delete: function($event) {
                              return _vm.deleteSubParameter(index)
                            },
                            "toggle-edit": function($event) {
                              return _vm.toggleEdit(index, $event)
                            },
                            update: function($event) {
                              return _vm.updateSubParameter(index, $event)
                            }
                          }
                        })
                      ],
                      1
                    )
                  }),
                  0
                )
              ],
              1
            )
          ])
        ]),
        _c("div", { staticClass: "col-md-12 mt-3" }, [
          _vm.error
            ? _c("div", { staticClass: "alert alert-danger" }, [
                _vm._v(" " + _vm._s(_vm.error) + " ")
              ])
            : _vm._e(),
          _c(
            "div",
            { staticStyle: { float: "right" } },
            [
              _c(
                "vs-button",
                {
                  staticClass: "action",
                  attrs: {
                    color: "primary",
                    type: "border",
                    icon: "save",
                    disabled: _vm.isSaving
                  },
                  on: { click: _vm.save }
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.isSaving ? "Guardando..." : "Guardar") +
                      " "
                  )
                ]
              )
            ],
            1
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }